module.exports = __webpack_public_path__ + "static/media/q7.9717afa9.png";